import React from "react";
import { getField } from "../../util/DynamicItemUtils";

export default function GlobalNetworkFirm({ item }: any) {
  var href =
    "https://rasr.pcaobus.org/Firms/FirmSummaryPublic.aspx?FirmID=" +
    getField(item, "encryptedfirmid");

  return (
    <div>
      <p className="lead-text-lt">Global Network Firms</p>
      <h3>
        <a href={href}>{getField(item, "title")}</a>
      </h3>
      <div className="hawk-row inline">
        {getField(item, "firmname") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Firm Name</div>
            <div className="lead-text-st break-word">
              {getField(item, "firmname")}
            </div>
          </div>
        )}
        {getField(item, "globalnetwork") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Global Network</div>
            <div className="lead-text-st">
              {getField(item, "globalnetwork")}
            </div>
          </div>
        )}
        {getField(item, "city") && (
          <div className="hawk-column">
            <div className="lead-text-lt">City</div>
            <div className="lead-text-st">{getField(item, "city")}</div>
          </div>
        )}
        {getField(item, "country") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Country</div>
            <div className="lead-text-st">{getField(item, "country")}</div>
          </div>
        )}
        {getField(item, "hasinspectionreport") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Inspection report issued</div>
            <div className="lead-text-st">
              {getField(item, "hasinspectionreport")
                .replace("False", "No")
                .replace("True", "Yes")}
            </div>
          </div>
        )}
      </div>
      <a href={href} className="hawk-read-more">
        Read More
      </a>
    </div>
  );
}
